import { render, staticRenderFns } from "./FormDataViewer.vue?vue&type=template&id=2f47478e&scoped=true&"
import script from "./FormDataViewer.vue?vue&type=script&lang=js&"
export * from "./FormDataViewer.vue?vue&type=script&lang=js&"
import style0 from "./FormDataViewer.vue?vue&type=style&index=0&id=2f47478e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f47478e",
  null
  
)

export default component.exports